"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { infoIcon, arrowDown, arrowUp } from "../ui/header_icons";
import { Tooltip, TooltipDirection, TooltipLocation } from "../ui/v3/tooltip";
var CustomerMarginHeaderTooltipPlacement = /* @__PURE__ */ ((CustomerMarginHeaderTooltipPlacement2) => {
  CustomerMarginHeaderTooltipPlacement2["Before"] = "before";
  CustomerMarginHeaderTooltipPlacement2["After"] = "after";
  return CustomerMarginHeaderTooltipPlacement2;
})(CustomerMarginHeaderTooltipPlacement || {});
class CustomerMarginHeader extends React.Component {
  renderCustomerMargin() {
    var _a, _b;
    const dollarDifference = ((_a = this.props.invoice.customer_margin_data) == null ? void 0 : _a.dollarDifference) || 0;
    const dollarDifferenceString = this.formatDollars(dollarDifference);
    const percentDifference = ((_b = this.props.invoice.customer_margin_data) == null ? void 0 : _b.percentDifference) || 0;
    let icon;
    let percentString;
    if (percentDifference == 0) {
      icon = "";
      percentString = "";
    } else if (percentDifference < 0) {
      icon = arrowDown();
      percentString = `${Math.abs(percentDifference)}%`;
    } else {
      icon = arrowUp();
      percentString = `${percentDifference}%`;
    }
    let dangerStyle = {};
    if (dollarDifference < 0) {
      dangerStyle = { color: "var(--color-danger-700)" };
    }
    return /* @__PURE__ */ jsxs("div", { className: "v3__stack--horz v3__stack v3__stack--gap-xxxs", children: [
      /* @__PURE__ */ jsx("div", { className: "v3__stack-cell v3__stack-cell--size-fit", children: /* @__PURE__ */ jsx("span", { className: "v3__type__small-body", style: dangerStyle, children: dollarDifferenceString }) }),
      /* @__PURE__ */ jsx("div", { className: "v3__stack-cell v3__stack-cell--size-fit", children: /* @__PURE__ */ jsx("span", { style: dangerStyle, children: icon }) }),
      /* @__PURE__ */ jsx("div", { className: "v3__stack-cell v3__stack-cell--size-fit", children: /* @__PURE__ */ jsx("span", { className: "v3__type__small-body", style: dangerStyle, children: percentString }) })
    ] });
  }
  render() {
    return /* @__PURE__ */ jsx("div", { className: "enable_shared-ui-v3", children: /* @__PURE__ */ jsx("div", { className: "v3__theme", children: /* @__PURE__ */ jsxs("div", { className: "v3__stack--horz v3__stack v3__stack--gap-xxxs", children: [
      this.props.tooltipPlacement === "before" /* Before */ && this.renderTooltip(),
      /* @__PURE__ */ jsx("div", { className: "v3__stack-cell v3__stack-cell--size-fit", children: /* @__PURE__ */ jsxs(
        "span",
        {
          className: this.props.useV3Typography ? "v3__type__small-body-semi-bold" : "",
          children: [
            "Customer margin",
            this.props.labelValueSeparator || ""
          ]
        }
      ) }),
      /* @__PURE__ */ jsx("div", { className: "v3__stack-cell v3__stack-cell--size-fit", children: /* @__PURE__ */ jsx(
        "span",
        {
          className: this.props.useV3Typography ? "v3__type__small-body" : "",
          children: this.renderCustomerMargin()
        }
      ) }),
      this.props.tooltipPlacement === "after" /* After */ && this.renderTooltip()
    ] }) }) });
  }
  formatDollars(amount) {
    if (amount < 0) {
      return `-$${Math.abs(amount).toFixed(2)}`;
    } else if (amount > 0) {
      return `$${amount.toFixed(2)}`;
    } else {
      return "$0.00";
    }
  }
  renderTooltip() {
    var _a, _b;
    const customerCharge = ((_a = this.props.invoice.customer_margin_data) == null ? void 0 : _a.customerCharge) || 0;
    const carrierCharge = ((_b = this.props.invoice.customer_margin_data) == null ? void 0 : _b.carrierCharge) || 0;
    const toolTipContent = `Calculated as invoiced payable (${this.formatDollars(carrierCharge)}) deducted from the receivable (${this.formatDollars(customerCharge)}).`;
    return /* @__PURE__ */ jsx("div", { className: "v3__stack-cell v3__stack-cell--size-fit", children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(
      Tooltip,
      {
        content: infoIcon(),
        tooltipContent: toolTipContent,
        direction: TooltipDirection.Below,
        location: TooltipLocation.Middle,
        tooltipContentStyle: {
          width: "200px",
          top: "-10px",
          left: "-93px"
        }
      }
    ) }) });
  }
}
export { CustomerMarginHeader, CustomerMarginHeaderTooltipPlacement };
